import {
  ApplianceModel,
  ChipMinimizerModel,
  ColorModel,
  CommonProductModel,
  CornerRadiusModel,
  CutoutLaborModel,
  CutoutModel,
  DiagonalCornerModel,
  EdgeModel,
  JointPoint,
  OptionalProduct,
  PricedProduct,
  TearOutModel,
  WaterfallLabor,
} from '~/core/models';

// I'm leaving this here initially because I'm not convinced of the future of it as is
// and this is the only use we have for it to date
export type Product =
  | OptionalProduct
  | ApplianceModel
  | ChipMinimizerModel
  | ColorModel
  | CornerRadiusModel
  | CutoutModel
  | DiagonalCornerModel
  | EdgeModel
  | TearOutModel
  | WaterfallLabor // this doesn't have consumerDesc but probably should for consistency
  | CutoutLaborModel
  | PricedProduct
  | JointPoint;

export const getProductDescription = (
  product: CommonProductModel,
  useAbbrev?: boolean // explicitly try to use abbreviated description first
): string => {
  const abbrev =
    useAbbrev && 'abbrevDesc' in product ? product.abbrevDesc : null;
  const consumer = 'consumerDesc' in product ? product.consumerDesc : null;

  return abbrev ?? consumer ?? product.name;
};
